<div class="" style="justify-content: space-between; align-items: center; display: flex;">
  <div class="full-left">

    <button *ngIf="quyen_them===true" style="float:left" class="btn btn-info btn-bloc" (click)="adddata()">
      {{'Thêm mới' | translate}}
    </button>
    <button *ngIf="quyen_them===true" style="float:left;margin-left:3px" class="btn btn-info btn-bloc" (click)="adddata_nhieu()">
      {{'Thêm mới nhiều SP' | translate}}
    </button>
    <button type="submit" style="margin-left:3px" (click)="export('pdf')" class="mb-1 mr-1 btn btn-success">In hóa đơn</button>
    <button type="submit" style="margin-left:3px" (click)="export('xlsx')" class="mb-1 mr-1 btn btn-success">Xuất ra excel</button>
  </div>
  <div class="full-right">
    <!-- Add filter dropdown for phát/chưa phát status -->
    <label class="float-right" style="margin-right: 5px; margin-top: 5px;">Trạng thái phát:</label>
    <div class="float-right" style="margin-right: 10px;">
      <select class="form-control" [(ngModel)]="trangThaiPhat" (change)="search()">
        <option value="">-- Tất cả --</option>
        <option value="1">Đã phát</option>
        <option value="0">Chưa phát</option>
      </select>
    </div>
  </div>
</div>

<!-- lưới chi tiết -->
<div style="margin-left: 0px;margin-top: 0px;overflow:auto">
  <div style="padding: 2px 10px 10px 10px;color:black !important;height: calc(100vh - 150px)">
    <table id="fixTableQT" class="table table-striped table-bordered table-hover table-condensed">
      <thead>
        <tr class="thCenter">
          <th style="width:50px;text-align:center;background-color:#f3f8fc;color:black">{{'Chọn' | translate}}</th>
          <th style="width:50px;text-align:center;background-color:#f3f8fc;color:black">{{'STT' | translate}}</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc;color:black">{{'Ngày nộp' | translate}}</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc;color:black">{{'Ngày phát' | translate}}</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc;color:black">{{'Quyển số' | translate}}</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc;color:black">{{'Số phiếu' | translate}}</th>
          <th style="min-width:200px;text-align:center;background-color:#f3f8fc;color:black">{{'Tên sản phẩm' | translate}}</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc;color:black">{{'Số lượng' | translate}}</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc;color:black">{{'Thu phí' | translate}}</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc;color:black">{{'Số tiền' | translate}}</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc;color:black">{{'Phương thức' | translate}}</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc;color:black">{{'Kho' | translate}}</th>
          <th style="min-width:130px;text-align:center;background-color:#f3f8fc;color:black">{{'Ngày sửa' | translate}}</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc;color:black">{{'Người sửa' | translate}}</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc;color:black">{{'Ghi chú' | translate}}</th>
          <th style="width:150px;text-align:center;background-color:#f3f8fc;color:black"></th>
        </tr>
        <tr class="filter-row">
          <td style="text-align:center;background-color:#f3f8fc"><input type="checkbox" [(ngModel)]="TatCa" (click)="TichTatCa()" /></td>
          <td style="background-color:#f3f8fc"></td>
          <td style="background-color:#f3f8fc">
            <input class="form-control" style="width:100%;font-style:italic;height:22px !important" type="text"
                   [(ngModel)]="TimKiems.NgayThuTien" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
          </td>
          <td style="background-color:#f3f8fc">
            <input class="form-control" style="width:100%;font-style:italic;height:22px !important" type="text"
                   [(ngModel)]="TimKiems.Ngay" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
          </td>
          <td style="background-color:#f3f8fc">
            <input class="form-control" style="width:100%;font-style:italic;height:22px !important" type="text"
                   [(ngModel)]="TimKiems.QuyenSo" placeholder="Gõ nội dung tìm kiếm và ấn Enter" (keydown)=onKeydownEvent($event)>
          </td>
          <td style="background-color:#f3f8fc">
            <input class="form-control" style="width:100%;font-style:italic;height:22px !important" type="number"
                   [(ngModel)]="TimKiems.SoPhieu" placeholder="Gõ nội dung tìm kiếm và ấn Enter" (keydown)=onKeydownEvent($event)>
          </td>
          <td style="background-color:#f3f8fc">
            <input class="form-control" style="width:100%;font-style:italic;height:22px !important" type="text"
                   [(ngModel)]="TimKiems.Ten" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
          </td>
          <td style="background-color:#f3f8fc">
            <input class="form-control" style="width:100%;font-style:italic;height:22px !important" type="number"
                   [(ngModel)]="TimKiems.SoLuong" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
          </td>

          <td style="background-color:#f3f8fc"></td>
          <td style="background-color:#f3f8fc"></td>
          <td style="background-color:#f3f8fc"></td>


          <td style="background-color:#f3f8fc">
            <input class="form-control" style="width:100%;font-style:italic;height:22px !important" type="text"
                   [(ngModel)]="TimKiems.KhoHang" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
          </td>

          <td style="background-color:#f3f8fc"></td>
          <td style="background-color:#f3f8fc">
            <input class="form-control" style="width:100%;font-style:italic;height:22px !important" type="text"
                   [(ngModel)]="TimKiems.ModifiedBy" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
          </td>

          <td style="background-color:#f3f8fc">
            <input class="form-control" style="width:100%;font-style:italic;height:22px !important" type="text"
                   [(ngModel)]="TimKiems.GhiChu" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
          </td>
          <td style="background-color:#f3f8fc"></td>
        </tr>
      </thead>
      <tbody style="height:calc(100vh - 210px);">
        <!-- Add [ngClass] to highlight rows where u.Ngay is empty -->
        <tr *ngFor="let u of datas" [ngClass]="{'chua-phat': !u.Ngay}">
          <td style="text-align:center;width:50px"><input type="checkbox" [(ngModel)]="u.Tich" /></td>
          <td style="text-align:center;width:50px">{{u.STT}}</td>
          <td style="width:120px"><a (click)="editdata(u)">{{u.NgayThuTien | date:'dd/MM/yyyy'}}</a></td>
          <!-- Add warning badge for empty Ngay -->
          <td style="width:120px">
            <a (click)="editdata(u)">
              <span *ngIf="u.Ngay">{{u.Ngay | date:'dd/MM/yyyy'}}</span>
              <span *ngIf="!u.Ngay" class="badge badge-warning">Chưa phát</span>
            </a>
          </td>
          <td style="width:120px"><a (click)="editdata(u)">{{u.QuyenSo}}</a></td>
          <td style="width:120px"><a (click)="editdata(u)">{{u.SoPhieu}}</a></td>
          <td style="width:200px"><a (click)="editdata(u)">{{u.TenSanPham}}</a></td>
          <td style="width:120px;text-align:right"><a (click)="editdata(u)">{{u.SoLuong | number}}</a></td>
          <td style="width:120px"><a (click)="editdata(u)">{{u.DangKyS}}</a></td>
          <td style="width:120px;text-align:right"><a (click)="editdata(u)">{{u.SoTien | number}}</a></td>
          <td style="width:120px"><a (click)="editdata(u)">{{u.PhuongThucS}}</a></td>
          <td style="width:120px"><a (click)="editdata(u)">{{u.KhoHang}}</a></td>
          <td style="width:130px"><a (click)="editdata(u)">{{u.Modified |date:'dd/MM/yyyy HH:mm'}}</a></td>
          <td style="width:120px"><a (click)="editdata(u)">{{u.ModifiedBy}}</a></td>
          <td style="width:120px"><a (click)="editdata(u)">{{u.GhiChu}}</a></td>

          <td style="width:150px">
            <div style="float:left;padding-left:1px" *ngIf="quyen_them===true">
              <a (click)="editdata(u)" class="ng-binding" style="color:#1e6bb8 !important;font-weight:normal"><i class="mb-1 fa fa-edit"></i>{{'Sửa' | translate}} </a>
            </div>
            <div style="float:left;padding-left:1px">
              <a class="ng-binding" (click)="deletedata(u.Id)" style="color:#1e6bb8 !important;font-weight:normal">
                <i class="mb-1 far fa-trash-alt"></i>{{'Xóa' | translate}}
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="modal-footer" style="display: flex;justify-content: space-between;margin-top:5px;">
  <div>
    <ul class="pagination" style="display:flex;">
      <li [ngClass]="{disabled: currentPage === 1}">
        <a (click)="setPage(1)"><<</a>
      </li>
      <li [ngClass]="{disabled:currentPage === 1}">
        <a (click)="setPage(currentPage - 1)"><</a>
      </li>
      <li *ngFor="let page of pages" [ngClass]="{active: currentPage === page.Id}">
        <a (click)="setPage(page.Id)">{{page.Id}}</a>
      </li>
      <li [ngClass]="{disabled:currentPage === totalPages}">
        <a (click)="setPage(currentPage + 1)">></a>
      </li>
      <li [ngClass]="{disabled:currentPage === totalPages}">
        <a (click)="setPage(totalPages)">>></a>
      </li>
      <li>
        <input type="number" style="width:50px;height:25px;text-align:center" [(ngModel)]="pageSize" (blur)="search1()" />
      </li>
      <li><span style="font-weight:bold">Tổng số: {{totalItems | number}}</span></li>
    </ul>
  </div>
  <div class="">

    <!-- Add legend for row highlighting -->
    <div class="mt-2">
      <span class="badge badge-warning">Chưa phát</span> - Dòng có nền vàng nhạt là dụng cụ chưa được phát
    </div>
  </div>
</div>



<bs-modal #myModal class="modal fade show in" [cssClass]="'modal800'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">{{modalTitle}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="myModal.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-danhmuc-xuatkhoedit #dteChung (save)="saveModal($event)"></app-danhmuc-xuatkhoedit>
  </bs-modal-body>
</bs-modal>

<bs-modal #myModalNhieuSP class="modal fade show in" [cssClass]="'modal800'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">{{modalTitle}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="myModalNhieuSP.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-danhmuc-xuatkhonhieuedit #dteNhieuSP (save)="saveModal($event)"></app-danhmuc-xuatkhonhieuedit>
  </bs-modal-body>
</bs-modal>
